import { Delete, MoreVert, Visibility } from "@mui/icons-material";
import {
  Box,
  Grid,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import { useSnackbar } from "hooks/useSbackbar";
import useUserId from "hooks/useUserId";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const UploadedFilesTable = ({
  handleFileSelect,
  handleFileDelete,
  handleShowFile,
  selectedFile,
  hasApplied,
}) => {
  const { t } = useTranslation();
  const apiUrl = process.env.REACT_APP_API_URL;
  const userId = useUserId();
  const [userIdLoaded, setUserIdLoaded] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState({ resumes: null });
  const [uploadedFilesList, setUploadedFilesList] = useState({ resumes: null });
  const [localSelectedFile, setLocalSelectedFile] = useState(null);
  
  useEffect(() => {
    if (userId) {
      setUserIdLoaded(true);
    }
  }, [userId]);
  useEffect(() => {
  if (userIdLoaded && userId) {
    loadFiles();
  }
}, [userIdLoaded, userId]);

  useEffect(() => {
    setLocalSelectedFile(selectedFile);
  }, [selectedFile]);

  const handleRadioChange = (key, file) => {
    if (selectedFile === key) {
      handleFileSelect(null, null);
    } else {
      handleFileSelect(key, file);
    }
  };

  const loadFiles = async () => {
    try {
      console.log("userId check", userId);
      const response = await fetch(
        `${apiUrl}authentication/files-for-candidate/${userId.userId}/`
      );
      if (!response.ok) {
        throw new Error(`An error occurred: ${response.statusText}`);
      }
      const json = await response.json();
      console.log("json_upload_files", json);
      setUploadedFiles(json);
      setUploadedFilesList(json);
    } catch (error) {
      console.error("Error loading files:", error);
    }
  };
  const { showSnackbar } = useSnackbar();
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedKey, setSelectedKey] = useState(null);

  const handleMenuOpen = (event, key) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedKey(key);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };
  const standardizeFilename = (filename) => {
    let cleanName = filename.trim();
    cleanName = cleanName.replace(/\s+/g, "_");
    return cleanName;
  };

  return (
    <Grid item xs={12}>
      {hasApplied ? (
        <>
          {/* <Typography
            variant="h6"
            gutterBottom
            sx={{
              fontFamily: "Poppins",
              fontWeight: 600,
              fontSize: { xs: "18px", md: "22px" },
              lineHeight: "100%",
              letterSpacing: "0%",
              color: "#00000080",
              mt: 2,
            }}
          >
            {t("applicationForm.uploadedFiles")}
          </Typography>
          <Table>
            <TableHead
              sx={{
                backgroundColor: "#D9D9D933",
                "& tr:first-of-type": {
                  "& th:first-of-type": {
                    borderTopLeftRadius: "10px",
                    borderBottomLeftRadius: "10px",
                  },
                  "& th:last-of-type": {
                    borderTopRightRadius: "10px",
                    borderBottomRightRadius: "10px",
                  },
                },
              }}
            >
              <TableRow>
                <TableCell
                  sx={{
                    color: "#00000080",
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "100%",
                    letterSpacing: "0%",
                  }}
                >
                  {t("applicationForm.select")}
                </TableCell>
                <TableCell
                  sx={{
                    color: "#00000080",
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "100%",
                    letterSpacing: "0%",
                  }}
                >
                  {t("applicationForm.fileName")}
                </TableCell>
                <TableCell
                  sx={{
                    color: "#00000080",
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "100%",
                    letterSpacing: "0%",
                  }}
                >
                  {t("applicationForm.date")}
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    color: "#00000080",
                    fontFamily: "Poppins",
                    fontWeight: 500,
                    fontSize: "14px",
                    lineHeight: "100%",
                    letterSpacing: "0%",
                  }}
                >
                  {t("applicationForm.actions")}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.entries(uploadedFilesList).map(
                ([key, file]) =>
                  file && (
                    <TableRow key={key}>
                      <TableCell sx={{ color: "#000000" }}>
                        <Radio
                          checked={selectedFile === key}
                          onChange={() => handleRadioChange(key, file.resume || file)}
                          value={key}
                          sx={{
                            color: "#000000",
                            padding: "5px",
                            "&.Mui-checked": {
                              color: "#0017E7",
                            },
                            "&:hover": {
                              backgroundColor: "transparent",
                            },
                          }}
                          icon={
                            <Box
                              component="span"
                              sx={{
                                display: "block",
                                width: 18,
                                height: 18,
                                border: "1px solid #000000",
                                borderRadius: "4px",
                              }}
                            />
                          }
                          checkedIcon={
                            <Box
                              component="span"
                              sx={{
                                display: "block",
                                width: 18,
                                height: 18,
                                border: "1px solid #0017E7",
                                borderRadius: "4px",
                                backgroundColor: "#0017E7",
                                position: "relative",
                              }}
                            />
                          }
                        />
                      </TableCell>
                      <TableCell sx={{ color: "#000000" }}>
                        {file.resume ? `${t("applicationForm.resume")} ${key}` : `${t("applicationForm.file")} ${key}`}
                      </TableCell>
                      <TableCell sx={{ color: "#000000" }}>
                        {file.date
                          ? new Date(file.date).toLocaleDateString()
                          : new Date().toLocaleDateString()}
                      </TableCell>
                      <TableCell align="right">
                        <IconButton
                          aria-label="more"
                          aria-controls="file-menu"
                          aria-haspopup="true"
                          onClick={(event) => handleMenuOpen(event, key)}
                          sx={{ color: "#000000" }}
                        >
                          <MoreVert />
                        </IconButton>
                        <Menu
                          id="file-menu"
                          anchorEl={menuAnchorEl}
                          keepMounted
                          open={Boolean(menuAnchorEl) && selectedKey === key}
                          onClose={handleMenuClose}
                        >
                          <MenuItem
                            onClick={() => {
                              handleShowFile(selectedKey, file.resume || file);
                              handleMenuClose();
                            }}
                          >
                            <ListItemIcon>
                              <Visibility fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary={t("applicationForm.viewFile")} />
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              handleFileDelete(selectedKey);
                              handleMenuClose();
                            }}
                          >
                            <ListItemIcon>
                              <Delete fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary={t("applicationForm.deleteFile")} />
                          </MenuItem>
                        </Menu>
                      </TableCell>
                    </TableRow>
                  )
              )}
            </TableBody>
          </Table> */}
        </>
      ) : null}
    </Grid>
  );
};

export default UploadedFilesTable;
